import enviro from 'enviro';
import { BLOG_RESEARCH_AGENT_LISTING_SLUG, FEATURED_AGENT_LISTING_IDS_PROD, FEATURED_AGENT_LISTING_IDS_QA, FREE_ACCESS_AGENT_LISTING_IDS_PROD, FREE_ACCESS_AGENT_LISTING_IDS_QA } from '../constants/Agents';
export function getIsBlogResearchAgentListing(listingSlug) {
  return listingSlug === BLOG_RESEARCH_AGENT_LISTING_SLUG;
}
export function getIsFeaturedAgent(listingId) {
  const isQa = enviro.isQa();
  return isQa ? FEATURED_AGENT_LISTING_IDS_QA.includes(listingId) : FEATURED_AGENT_LISTING_IDS_PROD.includes(listingId);
}
export function getIsFreeAccessAgent(listingId) {
  const isQa = enviro.isQa();
  return isQa ? FREE_ACCESS_AGENT_LISTING_IDS_QA.includes(listingId) : FREE_ACCESS_AGENT_LISTING_IDS_PROD.includes(listingId);
}